/**
 * Read a Vite env var safely: trim, drop trailing slash, treat empty-string as
 * unset (??-only would let "" through and silently ship a broken URL — see the
 * MINTER_ARN incident on the BlobShip dashboard).
 */
function envOr(value: unknown, fallback: string): string {
  const v = typeof value === "string" ? value.trim().replace(/\/$/, "") : "";
  return v || fallback;
}

/** Base URL of the accounts API. Baked in at build time (Vite). */
export const API_URL: string = envOr(import.meta.env.VITE_API_URL, "http://localhost:8788");

/** Where the BlobShip product dashboard lives (Apps tile + "Open app" links go here). */
export const BLOBSHIP_APP_URL: string = envOr(
  import.meta.env.VITE_BLOBSHIP_APP_URL,
  "http://localhost:5173",
);
